module.exports = __webpack_public_path__ + "static/img/page_title_bg.b858f43.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/com/page_title_bg.png
// module id = cl4U
// module chunks = 27